import type { AuthState } from '@sunstone/store';
import { createAppStore } from '@sunstone/store';
import { authSyncMiddleware } from './middleware/authSync';

// In E2E test mode (VITE_SKIP_AUTH=true), Playwright sets window.__testAuth via
// addInitScript before the bundle loads. We read it here — synchronously, before
// createAppStore — so the auth state is baked into the initial Redux state.
const testAuth =
  import.meta.env.VITE_SKIP_AUTH === 'true' && typeof window !== 'undefined'
    ? ((window as Window & { __testAuth?: AuthState }).__testAuth ?? null)
    : null;

/**
 * Management plane app Redux store
 * Extends the base store with Auth0 sync middleware
 */
export const store = createAppStore({
  additionalMiddleware: [authSyncMiddleware],
  ...(testAuth ? { preloadedState: { auth: testAuth } } : {}),
});

// Re-export types and hooks from shared store
export type { AppDispatch, RootState } from '@sunstone/store';
export { useAppDispatch, useAppSelector } from '@sunstone/store';
